/**
 * @module geo/payload/facade/services
 */
import {SearchExecutionParameters} from '../../../functionalities/search';
import {Resource} from '../../../types/resource';
import {KindService} from '../../../types/services/kind.service';

import {SERVICE_CALL_METHOD} from './SERVICE_CALL_METHOD';
import { FunctionalityOptions } from '../../../types/functionality';
import { SERVICE_PAYLOAD } from './SERVICE_PAYLOAD';

/**
 * Action to reset current features on one or more layers
 * @since v 2.0.2
 */
export class SERVICE_EXECUTE_SEARCH extends SERVICE_PAYLOAD {
  public kindService: KindService = KindService.EXECUTE_SEARCH;

  parameters:ServiceExecuteSearchParameters;
  
  constructor(options: {parameters:ServiceExecuteSearchParameters,transient:boolean,id:string}) {
    super(options);
    this.parameters=options.parameters
    Object.assign(this.parameters, options.parameters);
  
  }
}
export interface ServiceExecuteSearchParameters{
   searches:  FunctionalityOptions[];
   params:SearchExecutionParameters; 
   id:string;
   eventSource:string
}
